/** Пока сайт-визитка только на портале baysport (бета). */
const WEBSITE_ALLOWED_SUBDOMAINS = new Set(["baysport"]);

export const WEBSITE_MODULE_PRICE_RUB = 4900;

export function isClubWebsiteAllowed(tenantOrSubdomain) {
  const sub =
    typeof tenantOrSubdomain === "string"
      ? tenantOrSubdomain
      : tenantOrSubdomain?.subdomain;
  return WEBSITE_ALLOWED_SUBDOMAINS.has(String(sub || "").trim().toLowerCase());
}

export function isWebsiteModulePurchased(tenantOrModule) {
  if (!tenantOrModule) return false;
  if (tenantOrModule.purchased != null) return Boolean(tenantOrModule.purchased);
  if (tenantOrModule.can_edit != null) return Boolean(tenantOrModule.can_edit);
  return Boolean(tenantOrModule.website_purchased_at);
}

export function formatPriceRub(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("ru-RU")} ₽`;
}
